import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/base/Seo";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import NewReleases from "./components/NewReleases";
import HotRank from "./components/HotRank";
import SerialNew from "./components/SerialNew";
import WhyUs from "./components/WhyUs";
import FaqPreview from "./components/FaqPreview";
import ContactCta from "./components/ContactCta";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "番木瓜漫画",
      description:
        "番木瓜漫画本季新作抢先看，新番导视、连载新开一站掌握，最新上架每日更新，热门新番同步追。",
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "番木瓜漫画",
      url: "/",
      email: "hello@fanmugua.example",
    },
  ];

  return (
    <>
      <Seo
        title="番木瓜漫画 - 本季新作抢先看，最新上架每日更新"
        description="番木瓜漫画本季新作抢先看，新番导视、连载新开一站掌握。每日更新番木瓜漫画最新上架内容，热门新番同步追，当季导视帮你快速锁定值得追的作品。"
        keywords="番木瓜漫画,番木瓜漫画本季新作,番木瓜漫画最新上架,番木瓜漫画新番导视,番木瓜漫画连载新开,番木瓜漫画热门新番"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <Featured />
        <NewReleases />
        <HotRank />
        <SerialNew />
        <WhyUs />
        <FaqPreview />
        <ContactCta />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}